const currentDate = new Date();
const numberOfDays = 2;
currentDate.setDate(currentDate.getDate()-numberOfDays);

export const filtrByEndsAt = (item)=>new Date(item.endsAt)>=currentDate